import { Typography } from "@material-ui/core"
import './TOS.css';

export const TOS = () => {
  return (
    <>
      <div id='TOS'>
        <Typography variant="h4" gutterBottom>
            Coming Soon!!!
        </Typography>
      </div>
    </>
  )
}